@if (newVersionBanner() && showNewVersionButton()) {
  <button
    class="w-full text-md bg-success-500 text-white py-md font-semibold"
    (click)="hardRefresh()">
    {{ 'app_new_version_available_label' | transloco }}
  </button>
}
